module.exports = __webpack_public_path__ + "img/banner.d206e762.png";